<template>
  <div>
    <sortable-table
      :table-header="tableHeader"
      :table-data="tableData"
      :page-size="getPageSize"
      :page-size-options="getPageSizeOptions"
      :max-pages="getMaxPages"
      :locale="getLocale"
      :additional-classes="additionalClasses"
    ></sortable-table>
  </div>
</template>

<script>
import SortableTable from '@/shared/components/tables/SortableTable.vue';

export default {
  name: 'ParticipantTable',
  components: {
    SortableTable,
  },
  props: {
    participants: {
      type: Array,
      required: true,
    },
    currentUserMyId: {
      type: String,
      required: false,
      default: null,
    },
  },
  inject: ['paging', 'locale'],
  data: () => ({
    tableData: [],
    tableHeader: [
      {
        name: 'firstName',
        isSortable: true,
        type: 'alphanumeric',
      },
      {
        name: 'lastName',
        isSortable: true,
        type: 'alphanumeric',
      },
      {
        name: 'street',
        isSortable: true,
        type: 'alphanumeric',
      },
      {
        name: 'zip',
        isSortable: true,
        type: 'alphanumeric',
      },
      {
        name: 'city',
        isSortable: true,
        type: 'alphanumeric',
      },
      {
        name: 'phone',
        isSortable: true,
        type: 'alphanumeric',
      },
    ],
    additionalClasses: 'participant-table',
  }),
  computed: {
    getPageSize() {
      return this.paging?.pageSize ?? 5;
    },
    getPageSizeOptions() {
      return this.paging?.pageSizeOptions ?? [5, 10, 25, 50];
    },
    getMaxPages() {
      return this.paging?.maxPages ?? 5;
    },
    getLocale() {
      return this.locale ?? 'de-DE';
    },
  },
  methods: {
    provideDefault(prop) {
      return prop ?? '-';
    },
    isAnyParticipantWaiting() {
      return this.participants.some((participant) => 'waitingPosition' in participant);
    },
    isAnyParticipantNumbered() {
      return this.participants.some((participant) => 'number' in participant);
    },
  },
  created() {
    this.tableData = this.participants.map((participant) => {
      const additionalClasses = [];
      const isParticipantCurrentUser = participant.myKwsUserId === this.currentUserMyId;
      if (isParticipantCurrentUser) {
        additionalClasses.push('bold');
      }
      return {
        number: {
          value: `${this.provideDefault(participant.number)}`,
          additionalClasses,
        },
        firstName: {
          value: `${this.provideDefault(participant.firstName)}`,
          additionalClasses,
        },
        lastName: {
          value: `${this.provideDefault(participant.lastName)}`,
          additionalClasses,
        },
        street: {
          value: `${this.provideDefault(participant.street)}`,
          additionalClasses,
        },
        zip: {
          value: `${this.provideDefault(participant.zip)}`,
          additionalClasses,
        },
        city: {
          value: `${this.provideDefault(participant.city)}`,
          additionalClasses,
        },
        phone: {
          value: `${this.provideDefault(participant.phone)}`,
          additionalClasses,
        },
        waitingPosition: {
          value: `${this.provideDefault(participant.waitingPosition)}`,
          additionalClasses,
        },
      };
    });
    if (this.isAnyParticipantWaiting()) {
      this.tableHeader.unshift({
        name: 'waitingPosition',
        isSortable: true,
        type: 'alphanumeric',
      });
    }
    if (this.isAnyParticipantNumbered()) {
      this.tableHeader.unshift({
        name: 'number',
        isSortable: true,
        type: 'alphanumeric',
      });
    }
  },
};
</script>

<style lang="scss" scoped>
::v-deep {
  .participant-table {
    thead th {
      hyphens: manual;
    }
    table.table tbody td {
      white-space: normal;
      hyphens: manual;
    }
  }
}
</style>
